import { makeStyles } from "@material-ui/core/styles";
import { MuiTheme } from "theme";

export default makeStyles((theme: MuiTheme) => ({
  newWorkOrderButton: {
    height: 30,
    backgroundColor: theme.palette.secondary.dark,
    color: "#f5fcf9",
    border: "none",
    whiteSpace: "nowrap",
    borderRadius: 2,
    padding: "5px 12px 5px 18px",
    "&:hover": {
      backgroundColor: "#7ad8b3"
    },
    [theme.breakpoints.down("xs")]: {
      height: 40
    }
  },
  newWorkOrderButtonText: {
    "&.MuiTypography-root": {
      color: "#f5fcf9",
      width: "100%",
      fontSize: 13,
      fontFamily: "SuisseIntlMedium",
      lineHeight: 1
    }
  },
  newOrderButtonIcon: {
    "& .MuiSvgIcon-root": {
      fontSize: 16
    }
  },
  compactDownXs: {
    [theme.breakpoints.down("xs")]: {
      height: 30,
      maxWidth: 46,
      minWidth: 46,
      padding: "6px 12px 4px",
      "& $newWorkOrderButtonText": {
        display: "none"
      },
      "& $newOrderButtonIcon": {
        margin: 0
      }
    }
  },
  showSmall: {
    height: 30,
    maxWidth: 46,
    minWidth: 46,
    padding: "6px 12px 4px",
    "& $newWorkOrderButtonText": {
      display: "none"
    },
    "& $newOrderButtonIcon": {
      margin: 0
    }
  }
}));
